import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "8731ba52-e096-469a-a68f-595776da7be9",
    content: "The maximum, frequency dependent,<br>pressure level that the subject can endure.",
    options: {},
  },
  {
    id: "fb8cc2f8-5278-4c29-affc-51b1c94c9a3c",
    content: "The range of hearing between a just audible sound<br>and the maximum sound that the subject can bear.",
    options: {},
  },
  {
    id: "adac020e-9baa-42de-b2d2-055f5a32e3a6",
    content:
      "The minimum, frequency dependent, pressure level that is<br>needed to create a hearing sensation for the subject.",
    options: {},
  },
  {
    id: "75efef3a-049f-432f-8ef5-2f62af05a36c",
    content:
      "The frequency independent pressure level that is<br>needed to create a hearing sensation for the subject.",
    options: {},
  },
];

export const task: Task = {
  id: "2f04fc3c-206a-4f26-9d19-a5ccb97bd586",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["adac020e-9baa-42de-b2d2-055f5a32e3a6"],
};
